module.exports = __webpack_public_path__ + "static/media/bursts_16.7921b192.svg";